import config from "config";
import { isAbsoluteUrl } from "utils/url";
import { timeoutPromise } from "utils/promise";
import packageInfo from "../../../../package.json";

const generateBaseUrl = () => {
  if (isAbsoluteUrl(config.webcodes.baseUrl)) {
    return new URL(config.webcodes.path, config.webcodes.baseUrl);
  }
  const baseUrl = window && window.location && window.location.origin;

  return new URL(config.webcodes.baseUrl + config.webcodes.path, baseUrl);
};

class WebcodeClient {
  constructor({ timeout = 2000 } = {}) {
    this.webcodeUrl = generateBaseUrl();
    this.timeout = timeout;
  }

  getWebcodeUrl(term) {
    const queryParameters = `${config.webcodes.queryParameter}=${term}`;
    let queryUrl = new URL(this.webcodeUrl);

    if (!queryUrl) {
      console.error("The configured Webcode URL is invalid");
      return;
    }

    queryUrl.search = queryParameters;

    return queryUrl;
  }

  fetchWebcodeTargetUrl(term) {
    const { name, version } = packageInfo;
    const identifierValue = name + "_" + version;
    const resolveData = (response) => {
      if (response.status === 200) {
        return response
          .json()
          .then((result) => {
            return result[0] && result[0].url;
          })
          .catch(() => Promise.reject("Server response was no valid json"));
      }

      if (response.status === 204) {
        // return null to differentiate between different responses
        return null;
      }

      return Promise.reject(Error("Error fetching webcode"));
    };

    const headers = {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        "X-CV-App-Identifier": identifierValue,
      },
    };

    const url = this.getWebcodeUrl(term);

    if (!url) {
      return Promise.reject();
    }

    return timeoutPromise(this.timeout, fetch(url.href, headers))
      .then(resolveData)
      .then((result) => Promise.resolve(result))
      .catch((e) => console.error(e));
  }
}

const webcodeClient = new WebcodeClient({ timeout: config.backend.timeout });

export const fetchWebcodeTargetUrl = (term) => {
  return webcodeClient.fetchWebcodeTargetUrl(term);
};

export const webcodeService = {
  fetchWebcodeTargetUrl,
};
